class Buttons {
	constructor() {
		this.buttons = document.querySelectorAll(".btn, .btn-alt");

		this.buttons.forEach( (button) => {

			// const text = `<span class='label'>${button.innerHTML}</span>`;
			const text = `${button.innerHTML}`;
			button.innerHTML = text;

			const element = document.createElement("span");
			element.innerHTML = `<svg width="18" height="14" viewBox="0 0 18 14" xmlns="http://www.w3.org/2000/svg">
<path class="arrow" d="M10.4235 13.7529C10.5807 13.9174 10.7728 13.9998 11 14C11.2272 13.9998 11.4228 13.9174 11.5868 13.7529L17.7632 7.57647C17.9208 7.41932 17.9998 7.22717 18 7C17.9998 6.77283 17.9208 6.57724 17.7632 6.41324L11.5868 0.236763C11.4228 0.0791615 11.2272 0.000240003 11 -1.30739e-06C10.7728 0.000239919 10.5807 0.0791614 10.4235 0.236763C10.2591 0.400772 10.1767 0.59636 10.1765 0.823528C10.1767 1.0507 10.2591 1.24285 10.4235 1.4L15.1897 6.17647L4.82353 6.17647C4.59636 6.17671 4.40421 6.25563 4.24706 6.41323C4.08259 6.57724 4.00024 6.77283 4 7C4.00024 7.22717 4.08259 7.41932 4.24706 7.57647C4.4042 7.74093 4.59636 7.82329 4.82353 7.82353L15.1897 7.82353L10.4235 12.5897C10.2591 12.7537 10.1767 12.9493 10.1765 13.1765C10.1767 13.4036 10.2591 13.5958 10.4235 13.7529Z"/>
<circle class="circle" cx="1" cy="7" r="1" transform="rotate(-180 1 7)"/>
</svg>`;
			element.classList.add('svg');
			button.appendChild(element);

		});
	}
}
